export default __webpack_public_path__ + "static/media/01-business.95091426.jpg";